import * as React from "react";
import { cn } from "../../lib/utils";

const TextArea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => {
  return (
    <textarea
      rows={3}
      className={cn(
        "w-full p-2 border rounded-md focus:border-b-2 border-gray-300 focus:outline-none focus:border-b-[#14B8A6] text-sm resize-none",
        className
      )}
      ref={ref}
      {...props}
    />
  );
});
TextArea.displayName = "Textarea";

export { TextArea };
